import { mapState, mapActions } from "vuex";
import { currencyIcons } from "@/helpers/GlobalVariables";

export const authComputed = {
  ...mapState("auth", {
    user: (state) => state.user,
    account: (state) => state.account,
    loggedIn: (state) => state.status.loggedIn,
    departments: (state) => state.departments,
    allUsers: (state) => state.allUsers,
    sources: (state) => state.sources,
    ticketDep: (state) => state.ticketDep,
  }),
};

export function theIcon(account) {
  let currency = currencyIcons;
  const selectedIcon = currency.find((icon) => {
    if (account.currency_format === "iso") {
      return icon.label.toUpperCase() === account.currency_name.toUpperCase();
    } else {
      return icon.label === account.currency_name;
    }
  });
  return selectedIcon
    ? account.currency_format === "iso"
      ? selectedIcon.label.toUpperCase()
      : selectedIcon.value
    : "$";
}

export const authMethods = mapActions("auth", [
  "login",
  "loginByOTP",
  "logout",
  "setAccount",
  "setDepartments",
  "setAllUsers",
  "setSources",
  "setTicketDep",
]);
